import { render, staticRenderFns } from "./distributionContrast1.vue?vue&type=template&id=3a95cb96&scoped=true&"
import script from "./distributionContrast1.vue?vue&type=script&lang=js&"
export * from "./distributionContrast1.vue?vue&type=script&lang=js&"
import style0 from "./distributionContrast1.vue?vue&type=style&index=0&id=3a95cb96&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a95cb96",
  null
  
)

export default component.exports